import { render, staticRenderFns } from "./saved-charts-admin-firebase.vue?vue&type=template&id=1d557a9d&"
import script from "./saved-charts-admin-firebase.vue?vue&type=script&lang=js&"
export * from "./saved-charts-admin-firebase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports